import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    chipLevel1: {
        backgroundColor: theme.palette.grey[100],
        margin: "5px 0px",
        padding: "5px 10px",
        borderRadius: "1%",
        "& label": {
            marginBottom: "unset",
            marginRight: "unset",
            "& .MuiFormControlLabel-label": {
                fontSize: ".75rem"
            }
        },
        "& .MuiSvgIcon-root": {
            fontSize: "1.2rem"
        }
    },
    chipLevel2: {
        backgroundColor: theme.palette.grey[200],
        margin: "5px 10px",
        padding: "5px 10px",
        borderRadius: "1%",
    },
    chipLevel3: {
        backgroundColor: theme.palette.grey[300],
        margin: "5px",
        padding: "0px 10px",
        borderRadius: "5%",
    }
}));

export default useStyles